<template>
  <div class="event">
    <BaseTitle
      v-if="item.performance && item.performance.title"
      :text="item.performance.title"
      size="xl"
      is-up
      class="event__name"
    />
    <ul class="event__list">
      <li v-if="date" class="event__item">{{ date }}</li>
      <li v-if="info" class="event__item">{{ info }}</li>
      <li v-if="hall" class="event__item">{{ hall }}</li>
    </ul>
    <div v-if="$slots.actions" class="event__actions">
      <slot name="actions" />
    </div>
    <div v-if="hasRulesLink" class="event__footer">
      <button
        type="button"
        class="terms-link"
        @click="$emit('show:rules')"
      >
        <mark>{{ $t('texts.refund') }}</mark>
      </button>
    </div>
    <slot />
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'Event',
  components: {
    BaseTitle,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    hasRulesLink: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    date() {
      const [day, weekday, time] = [
        { day: 'numeric', month: 'long' },
        { weekday: 'long' },
        { hour: '2-digit', minute: '2-digit' },
      ].map((options) => new Intl.DateTimeFormat(this.$i18n.locale, options).format(this.item.date));
      return `${day}, ${weekday}, ${time}`;
    },
    info() {
      const { age, duration } = this.item.performance || {};
      const durationText = duration ? this.$tc('pluralization.minute', duration) : '';
      const separator = age && durationText ? ', ' : '';
      return age + separator + durationText;
    },
    hall() {
      return this.item.hall?.title;
    },
  },
};
</script>

<style lang="stylus">
.event
  display block
  text-align center

  &__name
    padding-left 0.5em
    padding-right @padding-left

  &__list
    display block
    list-style none
    font-size 1.1em
    line-height 1.25
    padding 0
    margin 1em 0 0 0

  &__item
    margin-top 0.5em
    &:first-child
      margin-top 0

  &__actions
    margin-top 2em
    *
      margin-left 0.5em
      margin-right @margin-left

  &__footer
    margin-top 2em
    font-size 0.9em
</style>
